import { IUserSlim } from './user.model';

export enum OrganizationStatusEnum {
  NotInitialized = 'notInitialized',
  Pending = 'pending',
  Approved = 'approved',
  Declined = 'declined'
}

export type OrganizationStatus =
  OrganizationStatusEnum.NotInitialized |
  OrganizationStatusEnum.Pending |
  OrganizationStatusEnum.Approved |
  OrganizationStatusEnum.Declined;

  export const organizationStatusLabelMapping = {
    [OrganizationStatusEnum.NotInitialized] : 'primary',
    [OrganizationStatusEnum.Pending] : 'warning',
    [OrganizationStatusEnum.Approved]: 'success',
    [OrganizationStatusEnum.Declined]: 'error'
  };

export enum CountryEnum {
  Netherlands = 'Netherlands'
}

export const countryLabelMapping = {
  [CountryEnum.Netherlands] : 'Netherlands',
};

interface IOrganizationBase {
  id?: number;
  name: string;
  address: string;
  city: string;
  region: string;
  postalCode: string;
  coc: string;
  iban: string;
  country: CountryEnum;
  mobilePhone?: string;
  annualStaffTurnover: number;
  initialNumberOfCertificates: number;
  initialPercentageOfShares: number;
}

export interface IOrganizationSubmit extends IOrganizationBase {
  preferredNotaryUserId: number;
}

export interface IOrganization extends IOrganizationBase {
  certificatesBalance: number;
  investor: IUserSlim;
  status: OrganizationStatus;
  mfaEnabled?: boolean;
  mfaTestMode?: boolean;
}

export interface IOrganizationCreate {
  organizationName: string;
  investor: {
    firstName: string;
    lastName: string;
    email: string;
  };
}

export interface IOrganizationEdit {
  id?: number;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  address: string;
  city: string;
  region: string;
  postalCode: string;
  coc: string;
  iban: string;
  country: CountryEnum;
  mobilePhone?: string;
}
